module.exports = __webpack_public_path__ + "media/components/page-header/static/surf-forecast__logo--clear-697194039a5e99ccb298a7e994fe090d.png";